import { render } from "./PreSelect.vue?vue&type=template&id=752c9811&scoped=true&ts=true"
import script from "./PreSelect.vue?vue&type=script&lang=ts"
export * from "./PreSelect.vue?vue&type=script&lang=ts"

import "./PreSelect.vue?vue&type=style&index=0&id=752c9811&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752c9811"]])

export default __exports__